import apiClient from '@/services/axios'
import store from 'store'
import { notification } from 'ant-design-vue'

export async function login(email, password) {
  return apiClient
    .post('/auth/login', {
      email,
      password,
      role: 'dashboard',
    })
    .then((response) => {
      console.log(response, 'response login')
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      } else {
        return apiClient
          .post('/auth/login', {
            email,
            password,
            role: 'verificator',
          })
          .then((res) => {
            if (res) {
              const { accessToken } = res.data
              if (accessToken) {
                store.set('accessToken', accessToken)
              }
              res.data.role = 'YKI'
              return res.data
            } else {
              notification.warning({
                message: 'Gagal',
                description: 'Email / Password Salah',
                duration: 5,
              })
            }
          })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}
export async function loginNew(email, password, role) {
  return apiClient
    .post('/auth/login', {
      email,
      password,
      role,
    })
    .then((res) => {
      if (res) {
        const { accessToken } = res.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return res.data
      } else {
        notification.warning({
          message: 'Gagal',
          description: 'Email / Password Salah',
          duration: 5,
        })
      }
    })
    .catch((err) => {
      console.log(err)
    })
}

export async function loginverificator(email, password) {
  return apiClient
    .post('/auth/login', {
      email,
      password,
      role: 'verificator',
    })
    .then((response) => {
      console.log(response, 'response')
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch((err) => console.log(err))
}

export async function register(email, password, name) {
  return apiClient
    .post('/auth/register', {
      email,
      password,
      name,
    })
    .then((response) => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch((err) => console.log(err))
}

export async function currentAccount() {
  return apiClient
    .get('/auth/account')
    .then((response) => {
      if (response) {
        const { accessToken } = response.data
        if (accessToken) {
          store.set('accessToken', accessToken)
        }
        return response.data
      }
      return false
    })
    .catch((err) => console.log(err))
}

export async function logout() {
  store.remove('accessToken')
  return true
  // return apiClient
  //   .get('/auth/logout')
  //   .then(() => {
  //     store.remove('accessToken')
  //     return true
  //   })
  //   .catch(err => console.log(err))
}
